import { AgxApi } from '../../helpers/http';

export const poolCertificateApi = (authToken: string) =>
  new AgxApi('pools', authToken);
